import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import WorkOrderView from "components/Containers/WorkOrderView"
import {Tab, Tabs, Card, CardContent} from "@material-ui/core";

import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Types from "../../../../../constants/Types";
import {confirmAlert} from "react-confirm-alert";
import {toast} from "react-toastify";
import {PrintReceiptModal} from "../../../../../containers/Print";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Work Orders',
		url: '/work-orders',
		icon: 'wrench',
	}
];

class WorkOrder extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.tab = 'details'
		this.state.remaining = 0;
		this.transactionRef = React.createRef();
		this.transactionItemsRef = React.createRef();
		this.paymentsRef = React.createRef();
	}

	handleAfterSave = () => {
		this.setState({key: Math.random()})
	}
	handleDelete = () => {
		let model = new API.BuildClass(Types.Work_Orders._name, API.RequestType.DELETE);
		model.object.pkey = this.props.id;
		confirmAlert({
			title: 'Confirm Delete',
			message: (
				<span>
					This will delete all logs and entries tied to this work order. <strong>This will not refund payments or
					restock items if deleted.</strong> Are you sure you want to delete this?
				</span>
			),
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							await model.submit(null, API.RequestType.DELETE);
							this.props.history.push('/work-orders');

						} catch (error) {
							console.error(error);
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	handleCheckoutIncrement = () => {
		this.props.rootState.set({
			session_items_count: this.props.rootState.session_items_count === null ? 1 : 1 + this.props.rootState.session_items_count
		});
	}

	handlePrintReceipt = async () => {
		try {
			if (!this.transactionRef.current || !this.transactionItemsRef.current) {
				API.ToastId = toast.warning('Work order details are still loading. Please try again.', {
					position: toast.POSITION.TOP_CENTER,
				});
				return;
			}

			const customizationId = this.props.rootState.receiptCustomizationId;
			let rData = {items: [{}]};
			if (customizationId) {
				let rModel = new API.BuildClass(Types.Accounts_Customizations._name, API.RequestType.READ_ALL);
				rModel.parent = customizationId;
				rData = await rModel.submit(null, API.RequestType.READ_ALL);
			}

			const paymentData = this.paymentsRef.current?.state?.data ?? [];
			const transactionData = this.transactionRef.current.state;
			const transactionItemData = this.transactionItemsRef.current.state;
			const props = this.props;

			confirmAlert({
				customUI: ({onClose}) => {
					return (
						<PrintReceiptModal
							workOrder={true}
							onClose={onClose}
							account={this.props.rootState.account}
							data={transactionData}
							rData={rData}
							pData={paymentData}
							items={transactionItemData}
							props={props}
						/>
					);
				},
			});
		} catch (error) {
			console.error(error);
			API.ToastId = toast.error('Unable to open print receipt preview.', {
				position: toast.POSITION.TOP_CENTER,
			});
		}
	};

	handleSendReceipt = async () => {
		let {current} = this.transactionRef;
		current.sendReceipt.call({current}, null);
	};

	render() {
		const {tab} = this.state;
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/work-orders/${this.props.id}`,
				icon: 'edit',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button size={'sm'} className="primary-button" onClick={this.handlePrintReceipt} block={false}>Print
						Receipt</Button>
					<Button size={'sm'} className="secondary-button" onClick={this.handleSendReceipt}>Email Receipt</Button>
					{this.state.remaining > 0 && <Button className='primary-button' style={{ borderRadius: '6px' }} data-id="add-certificate" onClick={async () => {
						$.ajax({
							type: "PUT",
							url: APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/checkouts/work_orders',
							data: {
								object: JSON.stringify({
									checkout: "",
									work_order: this.props.id,
								}),
							},
							success: (data) => {
								API.ToastId = toast.info('Work order payment added to cart.', {
									position: toast.POSITION.TOP_RIGHT
								});
								this.handleCheckoutIncrement();
								this.props.history.push('/checkout');
							},
							error: function (xhr, status, error) {
								let errorMessage = xhr.responseJSON.response
								API.ToastId = toast.warning(errorMessage, {
									position: toast.POSITION.TOP_CENTER
								});
							}
						});
					}
					} size={"sm"}>
						<i className="fa fa-usd"/>&nbsp;&nbsp;Add Payment
					</Button>}
					<Button size={"sm"} className='danger-button' color="danger" onClick={this.handleDelete}>
						<i className="fa fa-ban"/>&nbsp;&nbsp;Delete
					</Button>
				</Framework.Components.PageBar>
				<Tabs value={tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Work Order" value="details"/>
					<Tab label="Payments" value="payments"/>
				</Tabs>
				<div style={{display: tab === 'details' ? 'block' : 'none'}}>
					<WorkOrderView
						key={this.state.key}
						refTransaction={this.transactionRef}
						refTransactionItems={this.transactionItemsRef}
						id={this.props.id}
						history={this.props.history}
						locations={this.props.locations}
						setRemaining={(val) => this.setState({remaining: val})}
					/>
				</div>
				<div style={{display: tab === 'payments' ? 'block' : 'none'}}>
					<Card>
						<CardContent>
							<Collections.WorkOrderPayments
								key={this.state.key}
								ref={this.paymentsRef}
								parent={this.props.id}
								history={this.props.history}
								reloadShell={this.props.reloadShell}
								reloadPage={this.refreshPage}
								reloadSelf={this.state.refresh}
							/>
						</CardContent>
					</Card>

				</div>
				<Framework.Elements.UniversalModal
					// isDev={APPCONFIG.settings.isDev()}
					parent={this.props.id}
					locations={this.props.locations}
					name={"Work Order"}
					title={'Make Payment'}
					submitLabel={'Submit Payment'}
					object={Objects.Payment}
					objectProps={{
						paymentModel: Types.Work_Orders_Payments._name,
					}}
					history={this.props.history}
					toggle={this.state['modalPayment']}
					reportClose={this.reportClose('modalPayment')}
					afterSave={this.handleAfterSave}
					size={'lg'}
				/>

			</div>
		)
	}
}

export default Framework.Components.withRootState(WorkOrder);
